import { MapLocation } from "./models/MapLocation";
import { MapLocationCollection } from "./models/MapLocationCollection";

export class MapLocationCollectionLoader {
    constructor(mapLocationsMap) {
        this._mapLocations = mapLocationsMap.locations;
    }

    load() {
        const mapLocationCollection = new MapLocationCollection();
        this._mapLocations.forEach((mapLocation) => mapLocationCollection.add(
            new MapLocation(mapLocation.name, mapLocation.x, mapLocation.y, mapLocation.url, mapLocation.desc)
        ));
        return mapLocationCollection;
    }
}